import { ScenarioWrapper, VisionStat } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { ScenarioVO } from '../../vo/scenarii/scenario.vo';

/**
 * retourne le nbr de lignes / values pour un scenar
 * Author LMA
 */
export class ScenarioStatsCmd extends WizCommand<VisionStat> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  public vo: ScenarioVO = null; // la vision porteuse des lignes à alimenter

  public do(scenario: ScenarioVO, callback: Function): ScenarioStatsCmd {
    this.vo = scenario;

    const wrapper: ScenarioWrapper = new ScenarioWrapper();
    wrapper.entity = scenario.source;
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.SCENARIO_STATS, wrapper, callback);
    return this;
  }

  public wizResult() {
    const stats: VisionStat = this.result;
    this.vo.stats = stats;
    super.wizResult();
  }

}
